<div id="role-popup" class="common-popup-block-doc pop-overrider">
    <form class="form" role="form" autocomplete="off" id="users-company-popup">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Añadir nuevo empresa</h2>
        </div>
        <div class="popoup-content">
            <div class="form-wrap-wrp">
            <div class="block-looper">
                <div class="form-wrap">
                    <app-tree-view (companyNode)="onCompanySelcted($event)" class="tree-view" [origin]="1">
                    </app-tree-view>
                </div>
            </div>
        </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="submit()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="cancel(true)"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>